export enum EnumOpportunityStatus {
  IN_PROGRESS='IN_PROGRESS',
  WON='WON',
  LOST='LOST',
  CANCELED='CANCELED'
}
